import EbzCollapse from './EbzCollapse';

export default EbzCollapse;
